import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELTitleIcon: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<circle
				cx="13.229"
				cy="13.229"
				r="3.9687"
				fillRule="evenodd"
				strokeWidth=".44304"
			/>
		</SvgIcon>
	);
};

export default ELTitleIcon;



// WEBPACK FOOTER //
// ./src/icons/ELTitleIcon.tsx